/**
 * Creates a display-friendly slug from a playlist name.
 * Note: This is only for display purposes. Actual slugs are generated and managed by the database.
 */
export function createPlaylistSlug(name: string): string {
  if (!name) return '';
  
  // Create base slug
  let baseSlug = name
    .toLowerCase()
    .replace(/[^\w\s-]/g, '') // Remove special chars except spaces and hyphens
    .trim()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens

  // Special case for R&B
  if (name.toLowerCase().includes('r&b')) {
    baseSlug = baseSlug.replace(/r-b/g, 'rb');
  }

  return baseSlug;
}

export function slugify(text: string | null | undefined): string {
  if (!text) return '';
  
  // Special case for R&B
  if (text.toLowerCase().includes('r&b')) {
    return 'rnb-soul';
  }
  
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove special chars except spaces and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
}

export function formatNumber(num: number): string {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
}

export function titleCase(str: string): string {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

// Helper function to get a deterministic daily seed
export function getDailySeed() {
  const date = new Date();
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

// Simple string hash function for deterministic shuffling
export function hashCode(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return hash;
}